import { IEventData } from 'meta/pages/v4/event'
import { ILocationData } from 'meta/pages/v4/location'
import { IUserTicketData } from 'meta/pages/v4/ticket'
import { ITypeTicketData } from 'meta/pages/v4/typeticket'
import { IWalletUserTicketDetails } from 'meta/pages/wallet'

export const getWalletTicketDetailsFromV4Entities = (
  event: IEventData,
  location: ILocationData,
  ticket: IUserTicketData,
  typeTicket: ITypeTicketData
): IWalletUserTicketDetails => {
  const ticketDetails: IWalletUserTicketDetails = {
    activationCard: ticket.fiscalData?.emission?.activationCard,
    buyerName: ticket.firstName ? `${ticket.firstName} ${ticket.lastName}` : `-`,
    dateEntry: ticket.events[0]?.entryDateTime?.date_tz,
    dateEvent: event.dateEvent.date_tz,
    eventTickets: ticket.seasonData?.events.map((x) => ({
      id: x.eventId,
      status: String(x.status.value),
      entryDateTime: x.entryDateTime?.date_tz,
    })),
    endDate_tz: ticket.validTo.date_tz ? new Date(ticket.validTo.date_tz) : null,
    emissionDate: ticket.fiscalData?.emission?.dateTime?.date_tz
      ? new Date(ticket.fiscalData?.emission?.dateTime?.date_tz)
      : null,
    emissionSystem: ticket.fiscalData.emissionSystem,
    eventName: event.name,
    exoNumber: event.ticketServiceType.exoNumber ?? null,
    fiscalProgressive: ticket.fiscalData.emission?.fiscalProgressive,
    fiscalSeal: ticket.fiscalData.emission?.fiscalSeal,
    id: ticket.id,
    isSeasonTicket: Boolean(ticket.seasonData && ticket.seasonData.eventCount > 0),
    locationName: location.name,
    openDateEvent: event.dateOpen.date_tz,
    orderCodeDescription: typeTicket.fiscalData.orderCode
      ? `${typeTicket.fiscalData.orderCode} - ${typeTicket.fiscalData.orderCodeDescription}`
      : null,
    organizerCompanyName: event.organizer.company,
    organizerVat: event.organizer.vat,
    numberOfEntrances: ticket?.seasonData?.eventCount ?? null,
    personalData: ticket.fiscalData.personalData
      ? {
          gender: ticket.fiscalData.personalData.gender?.label,
          birthplaceCityName: ticket.fiscalData.personalData.birthplaceCity?.name,
          birthplaceCountry: ticket.fiscalData.personalData.birthplaceCountry?.label,
          dateOfBirth: ticket.fiscalData.personalData.dateOfBirth.date_tz,
        }
      : null,
    phone: `(${ticket.phone.prefix}) ${ticket.phone.number}`,
    pvCode: ticket.fiscalData?.emission?.pvCode ?? null,
    presale: typeTicket.presale,
    price: typeTicket.price,
    seasonCode: ticket?.seasonData?.seasonCode ?? null,
    seasonProgressive: ticket?.seasonData?.seasonProgressive ?? null,
    secret: ticket.secret,
    status: ticket.status.key,
    statusLabel: ticket.status.label,
    ticketMoreData: ticket.ticketMore,
    totalPrice: typeTicket.total,
    ticketDescription: typeTicket.notes,
    typeTicketDescription: typeTicket.fiscalData?.typeTicket
      ? `${ticket.seasonData ? '' : `${typeTicket.fiscalData?.typeTicket} - `}${typeTicket.fiscalData?.typeTicketDescription}`
      : null,
    vatPermit: event.ticketServiceType.vatPermit ?? null,
  }

  return ticketDetails
}
